import { emptyObject, emptyList } from '@constants/empty';
import { DEFAULT_LANGUAGE_INFO } from '@cont/Practice/constants';
import isEmpty from 'lodash/isEmpty';

export const getModalState = ({ practiceSession }) =>
  practiceSession.modal || emptyObject;

export const getLatestSession = ({ practiceSession }) =>
  practiceSession.currentSession.latest_session_uid || '';

export const getFeedbackOptions = ({ practiceSession }) =>
  practiceSession.feedbackOptions || emptyObject;

export const getPracticeSelectedTopic = ({ practiceSession }) =>
  practiceSession.selectedTopic || emptyObject;

export const getPracticeTopologies =
  (goalUID) =>
  ({ practiceSession }) =>
    practiceSession.topologies?.[goalUID] || emptyList;

export const getSelectedTopic = ({ practiceSession }) =>
  practiceSession.selectedTopic || emptyObject;

export const getReminder =
  (goalUID) =>
  ({ practiceSession }) =>
    practiceSession.reminderByUID[goalUID] || emptyObject;

export const getIsReminderSettingsAvailable = (goalUID) => (state) => {
  const reminder = getReminder(goalUID)(state);

  return !isEmpty(reminder);
};

export const getIsReminderSettingsActive = (goalUID) => (state) => {
  const reminder = getReminder(goalUID)(state);

  return reminder.is_active || false;
};

export const getIsReminderDisplayable = (goalUID) => (state) => {
  const reminder = getReminder(goalUID)(state);

  return reminder.is_displayable || false;
};

export const getIsReminderDismissible = (goalUID) => (state) => {
  const reminder = getReminder(goalUID)(state);

  return reminder.is_dismissible || false;
};

export const getPracticeAvailableLanguages =
  (goalUID) =>
  ({ practiceSession }) =>
    practiceSession.availableLanguagesByGoalUID[goalUID] ??
    DEFAULT_LANGUAGE_INFO;

export const getUserPreferenceLanguage =
  (goalUID) =>
  ({ practiceSession }) => {
    const availableLanguageData =
      practiceSession.availableLanguagesByGoalUID[goalUID] || emptyObject;
    const languageData = availableLanguageData?.available_languages?.find(
      (languageObj) =>
        languageObj.code === availableLanguageData?.user_preference
    );
    return languageData;
  };

export const getSessionReport = ({ practiceSession }) =>
  practiceSession.sessionReport || emptyObject;

export const getWrongQuestionCountFromReport = ({ practiceSession }) =>
  practiceSession.sessionReport?.no_of_incorrect_question || 0;

export const getCurrentQuestionRank = ({ practiceSession }) =>
  practiceSession?.currentQuestion?.question_rank || 1;

export const getCurrentSession = ({ practiceSession }) =>
  practiceSession.currentSession || emptyObject;

export const getHasSubmitted = ({ practiceSession }) =>
  practiceSession.hasSubmitted;

export const getIsLastQuestion = ({ practiceSession }) =>
  practiceSession?.isLastQuestion || false;

export const getHasNoNextQuestion = ({ practiceSession }) =>
  isEmpty(practiceSession?.nextQuestion);

export const getQuestions = ({ practiceSession }) =>
  practiceSession.questions || emptyObject;

export const getIsPracticeSubmitting = ({ practiceSession }) =>
  practiceSession.isSubmitting;
